import { render, staticRenderFns } from "./BoardWriteQnaLayout.vue?vue&type=template&id=a788f08e&scoped=true&"
import script from "./BoardWriteQnaLayout.vue?vue&type=script&lang=js&"
export * from "./BoardWriteQnaLayout.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a788f08e",
  null
  
)

export default component.exports